/* unplugin-vue-components disabled */import script from "./ProjectDetailDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDetailDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDetailDetail.vue?vue&type=style&index=0&id=ac4238b8&scoped=true&lang=css"
import "./ProjectDetailDetail.vue?vue&type=style&index=1&id=ac4238b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac4238b8"]])

export default __exports__